export default __webpack_public_path__ + "static/media/filter-active.1538e48f.svg";